<template>
  <div>
    <div class="total-bar-container">
      <div class="title">
        {{ title }}
      </div>
      <div
        v-if="!hideTotal"
        class="total"
      >
        {{ displayTotal }}
      </div>
      <div
        class="icon-button"
        @click="toggleReview"
      >
        <img
          :src="require(`@/assets/checkout/chevron.svg`)"
          alt="toggle"
          :class="{ down: !reviewIsOpen }"
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TotalReviewBar",
  props: ["invoice", "reviewIsOpen", "toggleReview", "hideTotal"],
  computed: {
    title: function() {
      return this.hideTotal ? "Review Total" : "Auction Items Total";
    },
    displayTotal: function () {
      return this.invoice.invoice_total.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
    },
  },
};
</script>
<style scoped>
.total-bar-container {
  display: flex;
  padding: 0.5em 1.5em;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  background: #000;
  width: 100%;
}
.title, .total {
  color: var(--white, #fff);
  font-family: IBM Plex Sans;
  font-size: 1.125em;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  flex: 1;
}
.total {
    text-align: right;
    padding-right: 0.5em;
}
.icon-button {
  padding-top: 4px;
}
.down {
  transform: rotate(180deg);
}
.up {
  transform: rotate(360deg);
}
</style>